export default __webpack_public_path__ + "static/797-b605f745aba9732aa49c35088b94f6d0.gif";